export default __webpack_public_path__ + "static/suzanne-pols-99fa713f70e600c05aa120e2af96e2e0.jpg";